<td class="align-top">
    <app-input-text-group
        [trim]="true"
        [markTouchedOnChange]="false"
        [formControl]="formGroupFilter.controls.proBraLoc"></app-input-text-group>
</td>
<td class="align-top">
    <app-input-text-group
        [trim]="true"
        [markTouchedOnChange]="false"
        [formControl]="formGroupFilter.controls.name"></app-input-text-group>
</td>
<td class="align-top">
    <app-input-text-group
        [trim]="true"
        [markTouchedOnChange]="false"
        [formControl]="formGroupFilter.controls.email"></app-input-text-group>
</td>
<td class="align-top">
    <app-input-text-group
        [trim]="true"
        [markTouchedOnChange]="false"
        [formControl]="formGroupFilter.controls.phoneNumber"></app-input-text-group>
</td>
<td class="align-top">
    <app-input-date-group
        [formControl]="formGroupFilter.controls.occupationDate"></app-input-date-group>
</td>
<td class="align-top">
    <app-input-date-group
        [formControl]="formGroupFilter.controls.occupationEndDate"></app-input-date-group>
</td>
@if (showOnlineAccess()) {
    <td class="align-top">
        <app-input-dropdown-checkboxes
            [formControl]="formGroupFilter.controls.onlineAccess"></app-input-dropdown-checkboxes>
    </td>
}
<td class="last-col bg-transparent align-top"></td>
